import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as React from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import { Container, Navbar, Nav, Button } from 'react-bootstrap';
import Contacts from "./Components/Connection/Contacts";
import Shizobali from "./Components/Chromasomi/Shizobali";
import Footer from "./Components/FooterStaff/Footer";
import {FaPatreon, FaTelegramPlane, FaTwitch, FaYoutube} from "react-icons/fa";
import ButtonMUI from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import {FirstPage} from "./Components/StartPage/FirstPage";


function App() {
    return (
        <BrowserRouter>
            <Navbar
                variant="dark"
                expand="lg"
                sticky="top"
                className="main-navbar shadow-sm"
            >
                <Container>
                    <Navbar.Brand as={NavLink} to="/" end>
                        <h3>
                            Verum†
                        </h3>
                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls="main-navbar"/>
                    <Navbar.Collapse id="main-navbar">
                        <div className="mx-auto nav-buttons">
                            <Stack direction="row" spacing={1}>
                                <ButtonMUI
                                    component={NavLink}
                                    to="/"
                                    end
                                    className="nav-mui"
                                    variant="contained"
                                    disableElevation
                                >
                                    Шизобали
                                </ButtonMUI>

                                <ButtonMUI
                                    component={NavLink}
                                    to="/contact"
                                    className="nav-mui"
                                    variant="contained"
                                    disableElevation
                                >
                                    Зв'язок
                                </ButtonMUI>

                                <ButtonMUI
                                    component={NavLink}
                                    to="/bali"
                                    className="nav-mui"
                                    variant="contained"
                                    disableElevation
                                >
                                    Команди для чату стріма(soon)
                                </ButtonMUI>
                            </Stack>
                        </div>

                        <div className="footer-center">
                            <a href="https://www.youtube.com/@verum_t" aria-label="YouTube"><FaYoutube/></a>
                            <a href="https://www.twitch.tv/verumt" aria-label="Twitch"><FaTwitch/></a>
                            <a href="https://t.me/verumt" aria-label="Telegram"><FaTelegramPlane/></a>
                            <a
                                href="https://www.patreon.com/verumT?fan_landing=true"
                                aria-label="Patreon"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaPatreon/>
                            </a>

                        </div>

                    </Navbar.Collapse>

                </Container>
            </Navbar>

            <Routes>
                <Route path="/" element={<Shizobali/>}/>
                <Route path="/contact" element={<Contacts/>}/>
                <Route path="/bali" element={<FirstPage/>}/>
            </Routes>

            <Footer/>
        </BrowserRouter>
    );
}

export default App;
